import React from "react";
import R14, { View, Image } from "../core";
import Touchable from "../components/TouchableComponent";
import DateUtils from "../utils/DateUtils";

import JsonToCSV from "../utils/JsonToCSV";
import HtmlDecode from "../utils/HtmlDecode";
import SimpleMessageGridTableComponent from "../components/SimpleMessageGridTableComponent";
import SimpleMessageColumnTableComponent from "../components/SimpleMessageColumnTableComponent";
import { commonStyles } from "../assets/css/commonStyle";
import AddMessageIconComponent from "../components/AddMessageIconComponent";
import HeaderTitleComponent from "../components/HeaderTitleComponent";
import { customCommonStyles } from "../assets/css/customCommonStyle";
import attachedFileIcon from"../assets/images/attachedFileIcon.png";

const defaultSec = 60;

export default R14.connect(
  class SimpleMessageScreen extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        pageData: [],
        totalRows: 0,
        page: 1,
        lastSearchedTxt: "",
        pageReRender: 0,
      }
      this.timerInstance = null;
    }

    componentDidMount() {
      const { isMobileDevice } = this.props.app.dm.notificationDomain.state;
      if(isMobileDevice) {
        this.getPageData({}, {}, true);
        this.timerInstance = setInterval(async () => {
          const { isSearchOpen } = this.props.app.dm.userSearchDomain.state;
          if (!!isSearchOpen) return false;
          else {
            await this.getPageData({}, {}, false);
            this.setState({pageReRender: this.state.pageReRender + 1});
            this.props.app.dm.userSession.setState({ isLoading: false });
          }
        }, 1000 * defaultSec);
      }
    }

    componentWillUnmount() {
      if (this.timerInstance) {
        clearInterval(this.timerInstance);
      }
      this.setState({pageData: [], totalRows: 0, page: 1, lastSearchedTxt: "", pageReRender: 0});
    }

    onNavigate = (item) => {
      let newThreadId = item.threadId; //.replaceAll("#", ">>");
      this.props.app.dm.simpleMessage.setState({
        currentThreadId: newThreadId
      });
      this.props.app.nav.to("simpleMessageDetailRoute", { threadId: newThreadId });
    };

    convertToCSV = async (screenName = "data") => {
      let result = this.state.pageData;
      if (result && result.length) {
        result = result.map(item => {
          return {
            "Biller": item.billerName || item.biller.billerName,
            "Subject": item.subject,
            "Last Message": item.lastMessage,
            "Date": DateUtils.formatDate(item.lastMessageDate)
          }
        })
        const csvContent = JsonToCSV.convertJsonToCSV(result);
        HtmlDecode.downloadUTF8file({
          content: csvContent,
          filename: `${screenName}_${DateUtils.formatYYYYMMDDHHMMSS()}.csv`
        })
      }
      return false;
    }

    getPageData = async (
      query = {},
      options = {},
      loaderShown = true
    ) => {
      try {
        if(loaderShown) this.props.app.dm.userSession.setState({ isLoading: true });
        if (!this.props.app) return { pageData: [], totalRows: 0 };
        const {lastSearchedTxt, pageReRender} = this.state;
        const { page = null, rowsPerPage = 10, sortColumnName, search = null } = query;
        // if search has value then search by search else search by last search state (to prevent data while setTimeout)
        const searchTxt = search === null ? lastSearchedTxt : search;
        const pageNo = page === null ? this.state.page : page;
        let res = !this.props.app ? {} : await this.props.app.dm.simpleMessage.getSimpleMessages(
          {
            page: pageNo,
            resultsPerPage: rowsPerPage,
            search: searchTxt,
            ...(sortColumnName ? {sort: [{  field: "lastMessageDate", order: "DESC"  }]} : {})
          }
        );
        this.setState({pageData: res.nodes, totalRows: res.totalCount, page: pageNo, lastSearchedTxt: searchTxt, pageReRender: pageReRender + 1});
        return {
          pageData: res.nodes,
          totalRows: res.totalCount
        };
      } catch (error) {
        this.setState({pageData: [], totalRows: 0, pageReRender: 1});
        return {
          pageData: [],
          totalRows: 0,
          lastSearchedTxt: ''
        };
      } finally {
        this.props.app.dm.userSession.setState({ isLoading: false });
      }
    }

    render() {
      const { isMobileDevice } = this.props.app.dm.notificationDomain.state;
      const { pageData, totalRows, page, lastSearchedTxt, pageReRender } = this.state;
      return (
        <View style={[customCommonStyles.childMainContainer]}>
              <HeaderTitleComponent
                title={this.props.r14.navigation.currRoute._config.label}
                convertToCSV={() => this.convertToCSV("Message Biller")}
                getPageData={this.getPageData}
                isSearchIcon={true}
                searchText={lastSearchedTxt}
                isAddMessage={true}
                downloadCsv={true}
                dataSort={false}
                sortingFields={[{key: 'Date', value: 'lastMessageDate'}]}
              />
              <View style={[commonStyles.flex1, commonStyles.flexDirectionRow, customCommonStyles.webPAMchildContainer]}>
                {isMobileDevice ? (
                  pageReRender >= 1 || pageData.length ? 
                  <SimpleMessageColumnTableComponent
                    onProfileIcon={(item) => this.onNavigate(item)}
                    getPageData={this.getPageData}
                    pageData={pageData}
                    totalRows={totalRows}
                    page={page}
                    rowsPerPage={10}
                    isSimpleMessageScreen={true}
                    message={"No messages to display."}
                  /> : null
                ) : (
                <SimpleMessageGridTableComponent
                  name={'clients'}
                  labelKeys={[
                    {label: "Biller"},
                    {label: "Subject"},
                    {label: "Last Message", },
                    {label: "Date",}, //  sortable: true},
                    {label: "Action", width: 130}
                  ]}
                  labelValues={["billerName", "subject", "lastMessage", "lastMessageDate", "Detail"]}
                  onActionClick={(item, act) => console.log(item, act)}
                  onProfileIcon={(item) => this.onNavigate(item)}
                  message={"No messages to display."}
                  dateTypeFields={["lastMessageDate"]}
                  profileIcon={"billerName"}
                  searchable={true}
                  rowControlsRight={null}
                  getPageData={this.getPageData}
                  autoRefresh={defaultSec}
                  rowsPerPage={10}
                  isSimpleMessageScreen={true}
                  headerControlsRight={[ 
                    <View style={[commonStyles.flex1, commonStyles.flexDirectionRow, commonStyles.alignItemsCenter]}>
                      <View style={[commonStyles.paddingRight16]} >
                        <Touchable tooltip={'Export to CSV'} onPress={() => this.convertToCSV("Message Biller")}>
                          <Image source={attachedFileIcon} style={commonStyles.icon18} />
                        </Touchable>
                      </View>
                      <AddMessageIconComponent />
                    </View>
                  ]}
                />
              )}
              </View>
        </View>
      );
    }
  }
);
